import * as v from "valibot";
import type { ApiSchema } from "../api/schema.ts";
import { SupplierSchema, TenderPackageStatus } from "../types/package";

const AwardStateSchema = v.strictObject({
  id: v.string(),
  status: v.picklist([TenderPackageStatus.AWARDED, TenderPackageStatus.REVIEW]),
});

// An award always names who submitted; only stored packages may lack them
const AwardedSupplierSchema = v.object({
  ...SupplierSchema.entries,
  submitterIds: v.pipe(v.array(v.string()), v.minLength(1)),
});

const AwardBodySchema = v.object({
  assessmentPackageId: v.string(),
  suppliers: v.array(AwardedSupplierSchema),
});

export const packagesApi = {
  award: {
    method: "POST",
    path: "/package/award",
    description: "Awards a package in Review to the chosen suppliers.",
    context: "workspace",
    input: AwardBodySchema,
    output: v.object({ data: AwardStateSchema }),
  },
  unaward: {
    method: "DELETE",
    path: "/package/award",
    description: "Unaward a supplier.",
    context: "workspace",
    input: v.object({ assessmentPackageId: v.string() }),
    output: v.object({ data: AwardStateSchema }),
  },
} satisfies ApiSchema;
